'use client';

import { c as _c } from "react/compiler-runtime";
import { DesktopAppSeenReporter } from './desktop-app-seen-reporter';
import { DesktopDeepLinkReceiver } from './desktop-deep-link-receiver';
import { DesktopHistoryNavigationProvider } from './desktop-history-navigation-provider';
import { DesktopNotificationWarmUp } from './desktop-notification-warm-up';
import { DesktopQueuePreloader } from './desktop-queue-preloader';
import { DesktopStartInTray } from './desktop-start-in-tray';
import { DesktopTrayBadgeProvider } from './desktop-tray-badge-provider';
import { DesktopWakeRefresh } from './desktop-wake-refresh';
import { useToDesktop } from './todesktop-auth-provider';

/**
 * Everything the desktop app's main window adds on top of the web app. Mounted only inside the
 * desktop app, so none of these components checks for it itself.
 */
export function DesktopAppIntegrations() {
  const $ = _c(1);
  const {
    isDesktopApp
  } = useToDesktop();
  if (!isDesktopApp) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><DesktopStartInTray /><DesktopHistoryNavigationProvider /><DesktopTrayBadgeProvider /><DesktopWakeRefresh /><DesktopDeepLinkReceiver /><DesktopNotificationWarmUp /><DesktopQueuePreloader /><DesktopAppSeenReporter /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}